'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (contract, lastTickQuote) {
    var barrierEntryName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'barrier';

    var barrierValue = +contract[barrierEntryName];
    if (!barrierValue) {
        return lastTickQuote;
    }
    if (contract.barrierType !== 'relative') {
        return barrierValue;
    }
    if (typeof contract.entry_spot === 'undefined' && typeof lastTickQuote === 'undefined') {
        throw new Error('Relative barrier can not be calculated');
    }
    return barrierValue + (+contract.entry_spot || lastTickQuote);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/barrier/getAbsoluteBarrierFromContract.js
// module id = 7
// module chunks = 0